mutation updateInviteLeadToLandingpage($input: UpdateLeadsToLandingpageInput!) {
  updateInviteLeadToLandingpage(input: $input)
}
